import React, { Component } from 'react'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Container
 } from 'reactstrap';

export default class AppNavbar extends Component {
  state = {
    isOpen: false,
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div style={{paddingBottom: '56px'}}>
        <Navbar fixed="top" color="light" light expand="sm">
          <Container>
            <NavbarBrand href="/menu"><span style={{color: '#800020', fontWeight: 700}}>myLAUNSH</span> [Aright?]</NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
              <NavItem><NavLink href="/menu">Menu</NavLink></NavItem>
              <NavItem><NavLink href="/admin">Admin</NavLink></NavItem>
              <NavItem><NavLink href="/">Joke a di day</NavLink></NavItem>
              <NavItem><NavLink href="/">Contact</NavLink></NavItem>
              <NavItem><NavLink href="/">Feedback</NavLink></NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </div>
    )
  }
}
